import React from "react";
import { Nav, Navbar, Form } from 'react-bootstrap';
import Css from './Layout.module.css';

export default function Footer4Bottom1() {

    const d = new Date();
    const year = d.getFullYear();

    return (
        <div className={Css.Footer_Bottom1}>
            <label className="d-block text-center">© Copyright {year}. Magic Software (Thailand) Corp., Ltd. - All Rights Reserved. Version : {process.env.REACT_APP_VERSION}</label>
        </div>
    )
}